import { motion } from "framer-motion";
import { FiX, FiMapPin } from "react-icons/fi";

export default function CityModal({ city, onClose }) {
  return (
    <>
      {/* Backdrop */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        className="fixed inset-0 bg-black/60 z-40"
      />

      {/* Modal */}
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 100 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        className="fixed right-0 top-0 bottom-0 w-full max-w-md bg-terminalLight shadow-2xl z-50 overflow-y-auto border-l border-terminalBorder"
      >
        <div className="p-6">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 text-dimText hover:text-accentBlue transition-colors"
            aria-label="Close"
          >
            <FiX size={24} />
          </button>

          <div className="flex items-center gap-2 text-accentBlue mb-1">
            <FiMapPin size={18} />
            <span className="text-sm font-mono font-medium">
              {city.country}
            </span>
          </div>
          <h2 className="text-2xl font-bold text-brightText mb-1">
            {city.name}
          </h2>
          <p className="text-dimText text-sm font-mono mb-6">{city.dates}</p>
          <p className="text-dimText leading-relaxed mb-6">
            {city.description}
          </p>

          {city.photos && city.photos.length > 0 && (
            <div>
              {city.photos.map((photo, i) => (
                <img
                  key={i}
                  src={photo}
                  alt={`${city.name} ${i + 1}`}
                  className="rounded-lg w-full h-auto object-cover border border-terminalBorder"
                />
              ))}
            </div>
          )}

          {(!city.photos || city.photos.length === 0) && (
            <div className="bg-terminal rounded-xl p-8 text-center text-dimText text-sm font-mono border border-terminalBorder">
              Photos coming soon
            </div>
          )}
        </div>
      </motion.div>
    </>
  );
}
